import { render } from "./ClientsList.vue?vue&type=template&id=2d5f04e3"
import script from "./ClientsList.vue?vue&type=script&lang=js"
export * from "./ClientsList.vue?vue&type=script&lang=js"
script.render = render

export default script